import React from "react";
import { Container } from "./styles";
import { Portfolio } from "../Portfolio/Portfolio";

const Career = React.lazy(() => import("../Career/Career").then(m => ({ default: m.Career })));

export function Projects() {

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Container>
      <Portfolio isMain={true}></Portfolio>
      <React.Suspense fallback={<div />}>
        <Career></Career>
      </React.Suspense>
      <Portfolio></Portfolio>

        
    </Container>
  );
}
